import { Component, Input, OnInit } from '@angular/core';
import { style, state, animate, transition, trigger } from '@angular/animations';
import { DataService } from '../services/data.service';
import { FileSaverService } from 'ngx-filesaver';

@Component({
    selector: 'riga-pagamenti',
    templateUrl: './riga-pagamenti.component.html',
  styleUrls: ['./riga-pagamenti.component.css'],
  animations: [
    trigger('toggleAnimation', [
      state('close', style({
        height: "0px",
        overflow: "hidden"
      })),
      state('open', style({
        height: "*",
        overflow: "hidden"
      })),
      transition('close => open', animate('250ms ease-in')),
      transition('open => close', animate('250ms ease-out'))
    ]),
    trigger('toggleArrow', [
      state('close', style({
        transform: 'rotate(0)'
      })),
      state('open', style({
        transform: 'rotate(180deg)'
      })),
      transition('close => open', animate('250ms ease-in')),
      transition('open => close', animate('250ms ease-out'))
    ])
  ]
})
/** rigaPagamenti component*/
export class RigaPagamentiComponent implements OnInit {


  @Input()
  public pagamento: any;

  beneficiari:any[] = [];

  state: string = 'close';

  inizioValidita: Date;
  fineValidita: Date;

  blocked: boolean = false;
    /** rigaPagamenti ctor */
  constructor(private dataService: DataService, private fileSaverService: FileSaverService) {

  }

  ngOnInit(): void {
    let datePag = new Date(this.pagamento.data);
    this.inizioValidita = new Date(datePag.getFullYear(), datePag.getMonth(), datePag.getDay() + 1);
    if (datePag.getMonth() >= 9) {
      this.fineValidita = new Date(datePag.getFullYear() + 1, 11, 31);
    } else {
      this.fineValidita = new Date(datePag.getFullYear(), 11, 31);
    }
    
  }

  expand(idPagamento: number) {
    this.dataService.getBeneficiariPagamento(idPagamento).subscribe(result => {
      this.beneficiari = result;
      this.toggle();
    }, error => console.error(error));
  }

  toggle() {
    this.state = (this.state === 'close' ? 'open' : 'close');
  }

  getRicevuta() {
    this.dataService.getRicevutaPagamento(this.pagamento.id).subscribe(file => {
      this.fileSaverService.save(file, `ricevuta_${this.pagamento.id}.pdf`);
    });
  }
}
